import React, { useCallback } from 'react'
import { ActionableTable } from '../Table/ActionableTable'
import { useTranslation } from 'react-i18next'
import { useTheme } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import ContainedButton, {
  ContainedButtonVariant,
} from '../Buttons/ContainedButton'

export interface ExpiredActorsTableProps {
  rows: {
    roleName: string
    fullName: string
    firstName: string
    lastName: string
    subordinates: number
    actorKey?: number | string
  }[]
}

export const ExpiredActorsTable: React.FC<ExpiredActorsTableProps> = ({
  rows,
}) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const theme = useTheme()

  // Render a View Team button in the action column
  const renderActionButton = useCallback(
    (params: {
      row: {
        firstName: string
        lastName: string
        userKey: string
        actorKey: string
      }
    }) => {
      const { actorKey, userKey, firstName, lastName } = params.row
      return (
        <ContainedButton
          id={`view-team-${actorKey}`}
          variant={ContainedButtonVariant.ClickForDetails}
          css={{
            [theme.breakpoints.down('md')]: {
              marginLeft: 0,
            },
          }}
          onClick={() => {
            navigate('/team', {
              state: {
                userKey,
                actorKey,
                firstName,
                lastName,
              },
            })
          }}
        />
      )
    },
    [navigate, theme]
  )

  return (
    <ActionableTable
      rowHeight={35}
      columns={[
        {
          fieldName: 'roleName',
          columnHeaderName: t(
            'Dashboard.ExpiredActorsTable.Column.RoleName',
            'Role Name'
          ),
        },
        {
          fieldName: 'fullName',
          columnHeaderName: t(
            'Dashboard.ExpiredActorsTable.Column.FullName',
            'Full Name'
          ),
        },
        {
          fieldName: 'subordinates',
          columnHeaderName: t(
            'Dashboard.ExpiredActorsTable.Column.Subordinates',
            'Subordinates'
          ),
        },
        {
          fieldName: 'actions',
          columnHeaderName: t(
            'Dashboard.ExpiredActorsTable.Column.Actions',
            'Actions'
          ),
          renderCell: renderActionButton,
        },
      ]}
      noResultsMessage={t(
        'Dashboard.ExpiredActorsTable.NoResults',
        'No Results Found'
      )}
      rows={rows}
    />
  )
}

export default ExpiredActorsTable
